// @flow

export const searchTerm = (val: string) => {
  window.location = `/search?keywords=${encodeURIComponent(val)}`
}

export const communitySort = (
  val: string,
  path: string = '/community',
  hasQuery: boolean = false
) => {
  if (!hasQuery) {
    window.location = `${path}?sort=${encodeURIComponent(val)}`
  } else {
    window.location = `${path}&sort=${encodeURIComponent(val)}`
  }
}

export const communitySearch = (
  val: string,
  path: string = '/community',
  hasQuery: boolean = false
) => {
  if (!hasQuery) {
    window.location = `${path}?keywords=${encodeURIComponent(val)}`
  } else {
    window.location = `${path}&keywords=${encodeURIComponent(val)}`
  }
}
